import React from 'react'

const NoDataFound = () => {
  return (
    <div className="py-16 px-4 text-center">
                                <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-slate-100 dark:bg-slate-800 mb-6">
                                    <span className="material-symbols-outlined text-5xl text-slate-400 dark:text-slate-500">
                                        search_off
                                    </span>
                                </div>
                                <h3 className="text-xl font-semibold text-slate-900 dark:text-slate-100 mb-3">
                                    No Data Found
                                </h3>
                                <p className="text-slate-500 dark:text-slate-400 max-w-md mx-auto mb-6">
                                    No data match your current filters for the selected period.
                                </p>

                            </div>
  )
}

export default NoDataFound
